import { useRestaurantModel } from './../../model'
import { IGetNamePayload } from './../../model/types'

// Сервер не держит отдачу страницы дольше: при таймауте код дозапросит клиент
const SERVER_CODE_TIMEOUT_MS = 3000

export const getRestCodePayload = (route: any): IGetNamePayload => ({
  platform: route.query.platform === 'rkeeper' ? 'r-keeper' : 'iiko',
  externalId: route.params.restaurant,
  qrType: route.query.qr_type ? route.query.qr_type.toString() : ''
})

export const getRestCodeOnLoadPage = async (route: any) => {
  if (process.server) {
    const restaurantModel = useRestaurantModel()
    try {
      return await restaurantModel.getCode({ ...getRestCodePayload(route), timeout: SERVER_CODE_TIMEOUT_MS })
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('getRestCodeOnLoadPage', e)
    }
  }
}
